<div class="x-product-badges">
  <x-badge
    *ngFor="let badge of badges; trackBy: 'id' | trackBy"
    [badge]="badge.name"
    [badgeIconUrl]="badge.badgeIconUrl"
  ></x-badge>
</div>
